import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Dos = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Product and Service</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-17.png'/>
            <p><b>Fig. 1.</b> Representative interaction with iMoAge biosensor design</p>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Text className='BaseText5'>iMoAge is a <b>Point of Care biosensor whose purpose is to evaluate inflammation levels using aptamers in the elderly.</b> Our product is intended to prevent frailty, early mortality, morbidity, and some age-related diseases. iMoAge´s test is a <b>multiplex lateral flow assay that with just a drop of blood will produce easy to interpret colorimetric results</b> upon biomarker detection, allowing convenient and specific evaluation of inflammation levels.<br/>It is worth mentioning that current methods of testing are inaccessible, expensive and time-consuming, as they require remote laboratories and trained staff. Consequently, <b>iMoAge will be the next geroscience tool that we help the doctors and civil society to have an early detection of age related diseases.</b><br/>The principle of our product is biosensing. By using aptamers that bind specific proteins,<b>the test generates a concentration dependent read-out signal.</b> In the absence of these proteins or biomarkers no signal is shown. For more information, visit the Project Description Section.</Text>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Dos;
